
// GA4: form_submit for every WPForms form submitted via AJAX (WPForms'
// default submission mode). Non-AJAX submissions are covered server-side,
// see becht_ga4_push_form_submit_on_complete() in functions/analytics.php.
$(document).on('wpformsAjaxSubmitSuccess', '.wpforms-form', function() {
    var match = /^wpforms-form-(\d+)$/.exec(this.id || '');
    // data-form-name is added to every form via the wpforms_frontend_form_atts
    // filter in functions/wpforms-customization.php - independent of the
    // (usually hidden) visible form title heading.
    var formName = $(this).data('formName');

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'form_submit',
        form_id: match ? Number(match[1]) : null,
        form_name: formName || null
    });
});
